import type { AssetScope } from '@/shared/types'
import type { Session } from './session-model'

/**
 * Known permissions. Capability changes append their own (e.g. `alerts:acknowledge`).
 * Asset-scoped evaluation (shop / line) arrives with the administration capability.
 */
export const PERMISSIONS = [
  'app:view',
  'system:about',
  'model-training:view',
  'model-registry:view',
  /** Delete models of the Model Registry (delete-models-from-registry). */
  'model-registry:delete',
  /** Download models as a .zip (download-models-as-zip). */
  'model-registry:download',
] as const
export type Permission = (typeof PERMISSIONS)[number]

/**
 * Pure permission check. `scope` is reserved: until asset-scoped RBAC exists, a permission is
 * treated as global.
 */
export function can(
  session: Session | null | undefined,
  permission: Permission,
  _scope?: AssetScope,
): boolean {
  if (!session) return false
  return session.permissions.includes(permission)
}
